import { render, staticRenderFns } from "./player-name-history.vue?vue&type=template&id=4e3d900c&"
import script from "./player-name-history.vue?vue&type=script&lang=js&"
export * from "./player-name-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports